import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress, Theme } from '@material-ui/core';

import Topbar from './Topbar';

const useStyles = makeStyles((theme : Theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56
    }
  }
}));

const AuthLayout = (props: any) => {
  const {
    children,
  } = props;
  const classes = useStyles();

  return (
    <>
      <Topbar />
      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={<LinearProgress />}>
            {children}
          </Suspense>
        </div>
      </div>
    </>
  );
}

AuthLayout.propTypes = {
  route: PropTypes.object
};

export default AuthLayout;
